import React, { FC } from "react";
import './entityHierarchy.css';
import Node from "./node";

export type Hierarchy = {
    label: string,
    node?: Hierarchy,
}

interface EntityHierarchyProps {
    title: string,
    tree?: Hierarchy,
    labelOnly?: boolean
}

const EntityHierarchy: FC<EntityHierarchyProps> = ({ title, tree, labelOnly }) => {

    return <div className="bg-white text-sm">
        <div className="flex flex-row justify-between mb-2">
            <div
                className="text-1xl text-portal-blue-primary-shade2 font-bold text-ellipsis bound-title"
                title={title}>{title}</div>
        </div>
        <ul>
            <li>
                <div className="flex flex-col ml-2">
                    <div className="flex flex-row">
                        {labelOnly ? null : <div className={`w-2 h-2 my-auto ${tree?.node ? 'bg-tree-grey' : 'bg-portal-blue-primary-shade2'}`}></div>
                        }
                        <div className="ml-2">{tree?.label}</div>
                    </div>{tree?.node
                        ? <Node label={tree.node.label} node={tree.node.node}></Node>
                        : null}
                </div>
            </li>
        </ul>
    </div>;
}

export default EntityHierarchy
